import {isArrayAndNotEmpty} from '../observations/Utils'

export const reminderTypes = {
    reminder: 'reminder',
    appointment: 'appointment',
}

export const sendMethodTypes = {
    sms: 'sms',
    email: 'email',
    voice: 'voice',
    pushNotification: 'pushNotification',
}

export const reminderStatus = {
    brandNew: 'brandNew',
    reschedule: 'reschedule',
    missed: 'missed',
    done: 'done',
}

export const reminderKeys = {
    repeat: 'repeat',
    description: 'description',
    frequency: 'frequency',
    instructions: 'instructions',
    dateTime: 'dateTime',
    startDate: 'startDate',
    endDate: 'endDate',
    time: 'time',
    type: 'type',
    appointmentType: 'appointmentType',
    earlyReminder: 'earlyReminder',
    sendMethod: 'sendMethod',
    recipient: 'recipient',
    timeOrDay: 'timeOrDay',
    oneTime: 'oneTime',
    otherAppointmentType: 'otherAppointmentType',
    otherFrequency: 'otherFrequency',
    otherInstructions: 'otherInstructions',
    additionalFrequency: 'additionalFrequency',
    additionalInstructions: 'additionalInstructions',
    additionalKeyList: 'additionalKeyList',
    frequencyOptions: 'frequencyOptions',
    instructionsOptions: 'instructionsOptions',
    // isRemindEarly: 'isEarlySendReminder',
    isRemindEarly: 'earlySendReminder',
}

export const GroupPharmacy = [
    'Analgesics',
    'Anesthetics',
    'AntiBacterials',
    'Antivirals',
    'Antidementia',
    'Antidepressants',
    'Blood Glucose',
    'Antifungals',
    'Cardiovascular',
    'Inflamatory Bowel',
    'Antigout',
    'Antinflamatories',
    'Antimigraine',
    'Ophthalmic',
    'Gastrointestinal',
    'Sexual Disorder',
    'Muscle Relaxants',
    'Sleep Disorder',
    'Hormonal',
    'Antiobesity',
    'Vitamins',
    'Dermatology',
    'Dental',
]

// export const InstructionsPharmacy = [
//     'No alcohol',
//     'If dose is missed take the next time do not double up doses',
//     'Other',
//     'Take with food',
//     'Take on an empty stomach',
//     'Avoid grapefruit juice',
//     'Store in a cool, dry place',
//     'Keep out of reach of children',
//     'Do not use if pregnant or breastfeeding',
//     'Take at the same time every day',
//     'Consult doctor before stopping medication',
//     'Do not crush or chew',
//     'Drink plenty of fluids',
//     'May cause drowsiness',
//     'Follow up with your doctor if symptoms persist',
//     'Report any unusual side effects',
// ]

// export const FrequencyPharmacy = [
//     'Take after meals',
//     'Once per day with Food',
//     'To be taken before bed',
// ]
export const RepeatPharmacy = ['day/s', 'week/s', 'month/s', 'year/s']

export const InstructionsPharmacy = [
    {
        label: 'General Usage Instructions',
        items: [
            {
                label: 'Take at the same time every day',
                value: 'Take at the same time every day',
            },
            {
                label: 'Take medication exactly as prescribed',
                value: 'Take medication exactly as prescribed',
            },
            {
                label: 'Take medication until the prescribed course is complete',
                value: 'Take medication until the prescribed course is complete',
            },
            {
                label: 'Use a medication calendar to track doses',
                value: 'Use a medication calendar to track doses',
            },
            {
                label: 'Take with a full glass of water',
                value: 'Take with a full glass of water',
            },
            {label: 'Take with food', value: 'Take with food'},
            {
                label: 'Take with a meal to reduce stomach upset',
                value: 'Take with a meal to reduce stomach upset',
            },
            {
                label: 'Take on an empty stomach',
                value: 'Take on an empty stomach',
            },
            {label: 'Do not crush or chew', value: 'Do not crush or chew'},
            {
                label: 'Consult doctor before stopping medication',
                value: 'Consult doctor before stopping medication',
            },
            {
                label: 'Follow dietary restrictions as advised by your doctor',
                value: 'Follow dietary restrictions as advised by your doctor',
            },
        ],
    },
    {
        label: 'Warnings and Special Notes',
        items: [
            {label: 'May cause drowsiness', value: 'May cause drowsiness'},
            {
                label: 'Avoid driving or operating machinery',
                value: 'Avoid driving or operating machinery',
            },
            {
                label: 'Be cautious of possible withdrawal symptoms',
                value: 'Be cautious of possible withdrawal symptoms',
            },
            {
                label: 'Avoid spicy or acidic foods if medication causes stomach irritation',
                value: 'Avoid spicy or acidic foods if medication causes stomach irritation',
            },
            {
                label: 'Do not take with certain medications (e.g., blood thinners)',
                value: 'Do not take with certain medications (e.g., blood thinners)',
            },
            {
                label: 'Do not take with dairy products',
                value: 'Do not take with dairy products',
            },
            {
                label: 'Do not take with alcohol-based beverages',
                value: 'Do not take with alcohol-based beverages',
            },
            {label: 'Avoid grapefruit juice', value: 'Avoid grapefruit juice'},
            {
                label: 'May interact with other medications',
                value: 'May interact with other medications',
            },
            {
                label: 'Be aware of potential drug interactions',
                value: 'Be aware of potential drug interactions',
            },
            {
                label: 'Consult your doctor if you experience severe headaches',
                value: 'Consult your doctor if you experience severe headaches',
            },
        ],
    },
    {
        label: 'Storage and Handling',
        items: [
            {
                label: 'Store in a cool, dry place',
                value: 'Store in a cool, dry place',
            },
            {label: 'Keep refrigerated', value: 'Keep refrigerated'},
            {
                label: 'Keep out of reach of children',
                value: 'Keep out of reach of children',
            },
            {
                label: 'Store away from light and moisture',
                value: 'Store away from light and moisture',
            },
            {
                label: 'Check expiration date before use',
                value: 'Check expiration date before use',
            },
            {
                label: 'Use a pill organizer if you have trouble remembering doses',
                value: 'Use a pill organizer if you have trouble remembering doses',
            },
        ],
    },
    {
        label: 'Special Conditions',
        items: [
            {
                label: 'Do not use if pregnant or breastfeeding',
                value: 'Do not use if pregnant or breastfeeding',
            },
            {
                label: 'Monitor blood sugar levels if diabetic',
                value: 'Monitor blood sugar levels if diabetic',
            },
            {
                label: 'Regularly check kidney and liver function',
                value: 'Regularly check kidney and liver function',
            },
            {
                label: 'Inform your doctor about any pre-existing health conditions',
                value: 'Inform your doctor about any pre-existing health conditions',
            },
            {
                label: 'Contact your healthcare provider if you have an allergic reaction',
                value: 'Contact your healthcare provider if you have an allergic reaction',
            },
            {
                label: 'Report any unusual side effects',
                value: 'Report any unusual side effects',
            },
        ],
    },
    {
        label: 'Monitoring and Reporting',
        items: [
            {
                label: 'Complete follow-up appointments as scheduled',
                value: 'Complete follow-up appointments as scheduled',
            },
            {
                label: 'Follow up with your doctor if symptoms persist',
                value: 'Follow up with your doctor if symptoms persist',
            },
            {
                label: 'Review medication instructions with your pharmacist',
                value: 'Review medication instructions with your pharmacist',
            },
            {
                label: 'Use a medication calendar to track doses',
                value: 'Use a medication calendar to track doses',
            },
            {
                label: 'Ensure proper hydration while on medication',
                value: 'Ensure proper hydration while on medication',
            },
        ],
    },
]

const FrequencyPharmacy = [
    {
        label: 'By Meal',
        items: [
            {label: 'Before meals', value: 'Before meals'},
            {label: 'After meals', value: 'After meals'},
        ],
    },
    {
        label: 'Daily Frequency',
        items: [
            {label: 'Once daily with food', value: 'Once daily with food'},
            {label: 'Twice daily', value: 'Twice daily'},
        ],
    },
    {
        label: 'Time of Day',
        items: [
            {label: 'Morning and evening', value: 'Morning and evening'},
            {label: 'Every morning', value: 'Every morning'},
            {label: 'Every evening', value: 'Every evening'},
            {
                label: 'Every night before sleep',
                value: 'Every night before sleep',
            },
        ],
    },
    {
        label: 'Interval Between Doses',
        items: [
            {label: 'Every 2 hours', value: 'Every 2 hours'},
            {label: 'Every 4 hours', value: 'Every 4 hours'},
            {label: 'Every 5 hours', value: 'Every 5 hours'},
            {label: 'Every 6 hours', value: 'Every 6 hours'},
            {label: 'Every 8 hours', value: 'Every 8 hours'},
            {label: 'Every 12 hours', value: 'Every 12 hours'},
        ],
    },
    {
        label: 'Frequency Other',
        items: [
            {label: 'Every 3 days', value: 'Every 3 days'},
            {label: 'Every other day', value: 'Every other day'},
            {label: 'Twice weekly', value: 'Twice weekly'},
            {label: 'Once weekly', value: 'Once weekly'},
            {label: 'Once monthly', value: 'Once monthly'},
            {label: 'Every weekend', value: 'Every weekend'},
        ],
    },
    {
        label: 'Special Conditions',
        items: [
            {label: 'On an empty stomach', value: 'On an empty stomach'},
            {label: 'Only at bedtime', value: 'Only at bedtime'},
            {label: 'As needed', value: 'As needed'},
        ],
    },
]

const appointmentTypeOptions = [
    {label: 'Face-to-face appointment', value: 'Face-to-face appointment'},
    {label: 'Online appointment', value: 'Online appointment'},
    {label: 'Mental health check', value: 'Mental health check'},
    {label: 'Nurse visit', value: 'Nurse visit'},
    {label: 'Comprehensive health check', value: 'Comprehensive health check'},
    {
        label: 'Social welfare consultation',
        value: 'Social welfare consultation',
    },
    {label: 'General check-up', value: 'General check-up'},
    {label: 'Specialist consultation', value: 'Specialist consultation'},
    {label: 'Nutritional assessment', value: 'Nutritional assessment'},
    {label: 'Health advice', value: 'Health advice'},
    {label: 'Physical therapy treatment', value: 'Physical therapy treatment'},
    {label: 'Diagnostic testing', value: 'Diagnostic testing'},
    {label: 'Routine health check', value: 'Routine health check'},
    {label: 'Vaccination appointment', value: 'Vaccination appointment'},
    {label: 'Reproductive health check', value: 'Reproductive health check'},
    {label: 'Pediatric consultation', value: 'Pediatric consultation'},
    {label: 'Emergency visit', value: 'Emergency visit'},
    {label: 'Medication consultation', value: 'Medication consultation'},
    {label: 'Dental check-up', value: 'Dental check-up'},
    {label: 'Other', value: 'Other'},
]

export const componentTypes = {
    input: 'InputText',
    inputArea: 'InputArea',
    inputNumber: 'InputNumber',
    dropdown: 'DropDown',
    checkbox: 'CheckBox',
    calendar: 'Calendar',
    multiCheckbox: 'MultiCheckbox',
    fileUpload: 'FileUpload',
    multiSelect: 'MultiSelect',
    recipient: 'recipient',
}

const classnameDialogTypes = {
    simple: 'col-12',
    double: 'col-6',
    tripble: 'col-4',
    quarable: 'col-3',
    pentable: 'col-9',
    grid: 'grid',
}

export const getEarlyReminderOptions = (timeOrDay = 'time') => {
    let options = []
    if (timeOrDay === 'day') {
        options = Array.from({length: 5}, (v, i) => ({
            label: `${i + 1} day${i > 0 ? 's' : ''}`,
            value: i + 1,
        }))
    }
    if (timeOrDay === 'time') {
        options = Array.from({length: 22}, (v, i) => ({
            label: `${i + 1} hour${i + 1 > 1 ? 's' : ''}`,
            value: i + 1,
        }))
    }
    return options
}

const convertStringListToArr = (arr = []) => {
    let list = []
    if (!!isArrayAndNotEmpty(arr)) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i]) {
                let item = {label: arr[i], value: arr[i]}
                list.push(item)
            }
        }
    }
    return list
}

export const dialogMedicineContent = [
    // {
    //     key: reminderKeys.type,
    //     label: 'Type',
    //     component: componentTypes.dropdown,
    //     className: classnameDialogTypes.simple,
    //     options: [
    //         {label: 'Reminder', value: reminderTypes.reminder},
    //         {label: 'Appointment', value: reminderTypes.appointment},
    //     ],
    //     defaultValue: reminderTypes.reminder,
    //     isActive: [reminderTypes.appointment, reminderTypes.reminder],
    // },
    {
        key: reminderKeys.appointmentType,
        label: 'Appointment Type',
        component: componentTypes.dropdown,
        className: classnameDialogTypes.simple,
        options: appointmentTypeOptions,
        required: true,
        defaultValue: reminderTypes.reminder,
        isActive: [reminderTypes.appointment],
        // additionalKey: reminderKeys.otherAppointmentType,
    },
    {
        key: reminderKeys.otherAppointmentType,
        label: 'Other Appointment Type',
        component: componentTypes.inputArea,
        className: classnameDialogTypes.simple,
        isActive: [reminderTypes.appointment],
    },
    {
        key: reminderKeys.description,
        label: 'Description',
        component: componentTypes.input,
        className: classnameDialogTypes.simple,
        required: true,
        isActive: [reminderTypes.appointment, reminderTypes.reminder],
    },
    // {
    //     key: reminderKeys.recipient,
    //     label: 'Recipient',
    //     component: componentTypes.dropdown,
    //     className: 'col-7',
    //     required: true,
    //     options: [],
    //     isActive: [reminderTypes.appointment],
    // },
    {
        key: reminderKeys.recipient,
        label: 'Recipient',
        component: componentTypes.recipient,
        className: 'col-12',
        required: true,
        // options: [
        //     {label: 'SMS', value: sendMethodTypes.sms},
        //     {label: 'Email', value: sendMethodTypes.email, disabled: true},
        // ],
        isActive: [reminderTypes.appointment],
        defaultValue: 'sms',
    },
    {
        key: reminderKeys.frequency,
        label: 'Frequency',
        component: componentTypes.multiSelect,
        options: FrequencyPharmacy,
        additionalKey: reminderKeys.otherFrequency,
        configKey: reminderKeys.frequencyOptions,
        isActive: [reminderTypes.reminder],
    },
    {
        key: reminderKeys.otherFrequency,
        label: 'Other Frequency',
        component: componentTypes.inputArea,
        className: classnameDialogTypes.simple,
        isActive: [reminderTypes.reminder],
    },
    {
        key: reminderKeys.instructions,
        label: 'Instructions',
        component: componentTypes.multiSelect,
        className: classnameDialogTypes.simple,
        options: InstructionsPharmacy,
        additionalKey: reminderKeys.otherInstructions,
        configKey: reminderKeys.instructionsOptions,
        isActive: [reminderTypes.reminder],
    },
    {
        key: reminderKeys.otherInstructions,
        label: 'Other Instructions',
        component: componentTypes.inputArea,
        className: classnameDialogTypes.simple,
        isActive: [reminderTypes.reminder],
    },
    {
        key: reminderKeys.dateTime,
        label: 'Date Time',
        component: componentTypes.calendar,
        className: classnameDialogTypes.simple,
        additionalKey: reminderKeys.isRemindEarly,
        additionalLabel: 'Early Reminder ?',
        isActive: [reminderTypes.appointment, reminderTypes.reminder],
        showTime: true,
    },
    {
        key: reminderKeys.timeOrDay,
        label: 'Time Or Day',
        component: componentTypes.dropdown,
        className: 'col-3',
        options: [
            {label: 'Time', value: 'time'},
            {label: 'Day', value: 'day'},
        ],
        defaultValue: 'time',
        isActive: [reminderTypes.appointment],
    },
    {
        key: reminderKeys.earlyReminder,
        label: 'Early Reminder',
        component: componentTypes.dropdown,
        className: 'col-9',
        options: [
            {label: '1 day', value: 1},
            {label: '2 days', value: 2},
            {label: '3 days', value: 3},
            {label: '4 days', value: 4},
        ],
        isActive: [reminderTypes.appointment],
        defaultValue: 1,
    },
    {
        key: reminderKeys.startDate,
        label: 'From',
        component: componentTypes.calendar,
        className: classnameDialogTypes.double,
        defaultValue: '',
        isActive: [reminderTypes.reminder],
        // isActive: false,
    },
    {
        key: reminderKeys.endDate,
        label: 'To',
        component: componentTypes.calendar,
        className: classnameDialogTypes.double,
        defaultValue: '',
        isActive: [reminderTypes.reminder],
        // isActive: false,
    },
    {
        key: reminderKeys.time,
        label: 'Time',
        component: componentTypes.calendar,
        className: classnameDialogTypes.simple,
        // isActive: false,
        showTime: true,
        timeOnly: true,
        isActive: [reminderTypes.reminder],
    },
]

export const CalendarFormType = {
    patient: 'patient',
    reservation: 'reservation',
}
